/* eslint-disable complexity */
/* eslint-disable max-lines */
import { FC, Fragment } from "react"
import { Translate } from "../../../../../../constant/Translate"
import { ItemDatePickerRange } from "../../../../../../_webui/layout/components/Form/Item/DatePicker/Range"
import { ItemInput } from "../../../../../../_webui/layout/components/Form/Item/Input"
import { ItemSelect } from "../../../../../../_webui/layout/components/Form/Item/Select"
import { SchedulesFormSearchProps } from "./models"
import { Styled } from "./styled"
import { SelectItems } from "../../../../../../constant/SelectItems"
import { Regex } from "../../../../../../constant/Regex"
import { SchedulesItemGroup } from "../ItemGroup"
import { RadioItems } from "../../../../../../constant/RadioItems"

const { TRANSIT_SEARCH } = RadioItems
const { REGEX_IS_DESKTOP } = Regex
const { OTHER_CITY_SELECT_ITEMS } = SelectItems
const {
  StyledFormSearch,
  StyledGroup,
  StyledGroupLeft,
  StyledGroupRight,
  StyledItemAddon,
  StyledItemRadio,
} = Styled
const {
  TEXT_T009,
  TEXT_T025,
  TEXT_T039,
  TEXT_T168,
  TEXT_T191,
  TEXT_T192,
  TEXT_T193,
  TEXT_T194,
  TEXT_T195,
  TEXT_T196,
  TEXT_T197,
  TEXT_T203,
  TEXT_T210,
  TEXT_T215,
  TEXT_T217,
} = Translate

export const SchedulesFormSearch: FC<SchedulesFormSearchProps> = (props) => {
  const {
    arrivalCities,
    countries,
    departments,
    dispatchType,
    dispatchTypeDetail,
    form,
    handleSearch,
    isDisabledArrivalCity,
    isDisabledDispatchTypeDetail,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isPathnameSchedules,
    onBlurBasic,
    onChangeArrivalCity,
    onChangeArrivalCountryCode,
    onChangeDispatchType,
    onClickReset,
    onKeyDownBasic,
    purposeTravel,
  } = props

  return (
    <StyledFormSearch
      form={form}
      heading={TEXT_T191}
      isHiddenReset={!isHiddenBtnResetForm}
      isHiddenSubmit={!isHiddenBtnSearchBasic}
      labelAlign="left"
      onClickReset={onClickReset}
      onFinish={handleSearch}
      resetHtmlType="button"
    >
      <SchedulesItemGroup
        contentLeft={
          <Fragment>
            {isPathnameSchedules ? (
              <ItemInput isReadOnly label={TEXT_T192} name="fullName" />
            ) : (
              <ItemInput label={TEXT_T168} maxLength={102} name="fullName" />
            )}
            {!REGEX_IS_DESKTOP && (
              <ItemInput label={TEXT_T194} maxLength={200} name="projectName" />
            )}
          </Fragment>
        }
        contentRight={
          <ItemSelect
            label={TEXT_T193}
            name="countryToTravel"
            onChange={onChangeArrivalCountryCode}
            selectItem={countries}
          />
        }
      />

      <SchedulesItemGroup
        contentLeft={
          REGEX_IS_DESKTOP && (
            <ItemInput label={TEXT_T194} maxLength={200} name="projectName" />
          )
        }
        contentRight={
          !isPathnameSchedules && (
            <StyledItemAddon>
              <ItemInput
                addonBefore={
                  <ItemSelect
                    name="arrivalCityCode"
                    onChange={onChangeArrivalCity}
                    selectItem={[
                      ...(arrivalCities || []),
                      OTHER_CITY_SELECT_ITEMS,
                    ]}
                  />
                }
                isDisabled={isDisabledArrivalCity}
                label={TEXT_T217}
                maxLength={200}
                name="arrivalCity"
              />
            </StyledItemAddon>
          )
        }
      />

      <SchedulesItemGroup
        contentLeft={
          !isPathnameSchedules && (
            <ItemSelect
              label={TEXT_T009}
              name="bumonCd"
              selectItem={departments}
            />
          )
        }
        contentRight={
          <ItemDatePickerRange
            label={TEXT_T195}
            labelFrom={TEXT_T196}
            labelTo={TEXT_T197}
            name="travelDate"
            nameFrom="departureDateTimeDate"
            nameTo="arrivalDateTimeDate"
            onBlurFrom={(event) =>
              onBlurBasic(event, TEXT_T196, "departureDateTimeDate")
            }
            onBlurTo={(event) =>
              onBlurBasic(event, TEXT_T197, "arrivalDateTimeDate")
            }
            onKeyDownFrom={(event) =>
              onKeyDownBasic(event, TEXT_T196, "departureDateTimeDate")
            }
            onKeyDownTo={(event) =>
              onKeyDownBasic(event, TEXT_T197, "arrivalDateTimeDate")
            }
          />
        }
      />

      <StyledGroup>
        <StyledGroupLeft>
          <SchedulesItemGroup
            contentLeft={
              isPathnameSchedules ? (
                <ItemInput isReadOnly label={TEXT_T039} name="dispatchType" />
              ) : (
                <ItemSelect
                  label={TEXT_T039}
                  name="dispatchType"
                  selectItem={dispatchType}
                  onChange={(value) => {
                    onChangeDispatchType(value)
                    form?.setFieldValue("dispatchTypeDetail", "")
                  }}
                />
              )
            }
            contentRight={
              <ItemSelect
                label={TEXT_T215}
                name="travelPurposeId"
                selectItem={purposeTravel}
              />
            }
          />

          <SchedulesItemGroup
            contentLeft={
              isPathnameSchedules ? (
                <ItemInput
                  isReadOnly
                  label={TEXT_T025}
                  name="dispatchTypeDetail"
                />
              ) : (
                <ItemSelect
                  isDisabled={isDisabledDispatchTypeDetail}
                  label={TEXT_T025}
                  name="dispatchTypeDetail"
                  selectItem={dispatchTypeDetail}
                />
              )
            }
            contentRight={
              <ItemInput
                label={TEXT_T203}
                maxLength={100}
                name="departureFlightNumber"
              />
            }
          />

          <SchedulesItemGroup
            contentLeft={<Fragment></Fragment>}
            contentRight={
              <ItemInput label={TEXT_T210} maxLength={200} name="lodgingName" />
            }
          />
        </StyledGroupLeft>
        <StyledGroupRight>
          <StyledItemRadio
            name="transitSearchType"
            radioItems={TRANSIT_SEARCH}
          />
        </StyledGroupRight>
      </StyledGroup>
    </StyledFormSearch>
  )
}
